import React, { createContext, useContext, useMemo } from 'react';

const getIsSlateSkin = (): boolean => {
  const slateDomain = process.env.SLATE_DOMAIN;
  if (!slateDomain) return false;
  return location.hostname.toLowerCase() === slateDomain.toLowerCase();
};

const isSlateVehicle = (inventoryType?: string | null): boolean => {
  return inventoryType?.toLowerCase() === 'slate';
};

interface SlateContextValue {
  isSlateSkin: boolean;
  isSlateVehicle: boolean;
}

const SlateContext = createContext<SlateContextValue>({
  isSlateSkin: false,
  isSlateVehicle: false
});

interface SlateProviderProps {
  inventoryType?: string | null;
}

const SlateProvider: React.FC<React.PropsWithChildren<SlateProviderProps>> = ({
  inventoryType,
  children
}) => {
  const value = useMemo(
    () => ({
      isSlateSkin: getIsSlateSkin(),
      isSlateVehicle: isSlateVehicle(inventoryType)
    }),
    [inventoryType]
  );

  return <SlateContext.Provider value={value}>{children}</SlateContext.Provider>;
};

const useSlate = () => useContext(SlateContext);

export default SlateContext;
export { SlateProvider, useSlate };
